import React, { PureComponent } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Modal, {
  ModalFooter,
  ModalBody,
  ModalHeader,
  ModalTitle,
} from '@atlaskit/modal-dialog';
import SimpleTag from '@atlaskit/tag/simple-tag';
import Tooltip from '@atlaskit/tooltip';

import messages from './delete-branch-dialog.i18n';

type Props = {
  intl: InjectedIntl;
  isOpen: boolean;
  isDeleting: boolean;
  branchName: string;
  onClose: () => void;
  onDelete: () => void;
};

class DeleteBranchDialog extends PureComponent<Props> {
  render() {
    const { isOpen, branchName, onClose, onDelete, isDeleting, intl } =
      this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <Modal onClose={onClose} width="small">
        <ModalHeader>
          <ModalTitle appearance="danger">
            <FormattedMessage {...messages.dialogTitle} />
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Tooltip content={branchName}>
            <FormattedMessage
              {...messages.dialogDescription}
              values={{ branchLabel: <SimpleTag text={branchName} /> }}
            />
          </Tooltip>
        </ModalBody>
        <ModalFooter>
          <CustomThemeButton
            onClick={onDelete}
            isDisabled={isDeleting}
            isLoading={isDeleting}
            appearance="danger"
          >
            {intl.formatMessage(messages.deleteButton)}
          </CustomThemeButton>
          <CustomThemeButton onClick={onClose} isDisabled={isDeleting}>
            {intl.formatMessage(messages.cancelButton)}
          </CustomThemeButton>
        </ModalFooter>
      </Modal>
    );
  }
}

export default injectIntl(DeleteBranchDialog);
